var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { GET_LIMITS_SUCCESS } from 'app/shared/limits/limits.actions';
import { createSelector } from 'reselect';
export var initialState = {};
export function limitsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_LIMITS_SUCCESS:
            return __assign({}, state, action.payload);
        default: {
            return state;
        }
    }
}
var rootSelector = function (state) { return state.limits; };
var ɵ0 = rootSelector;
export var getLimitsSelector = createSelector(rootSelector, function (a) { return a; });
export { ɵ0 };
